import * as React from 'react';

const styles: React.CSSProperties = {
    animation: 'none',
    background: 'none',
    backgroundImage: 'none',
    bottom: 'auto',
    boxSizing: 'border-box',
    border: 'none',
    borderWidth: '0',
    color: 'rgba(255, 255, 255, .5)',
    display: 'block',
    filter: 'none',
    fontFamily: '"Lucida Console", Monaco, monospace',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    height: '34px',
    left: 'auto',
    letterSpacing: '0.05em',
    lineHeight: '12px',
    marginBottom: '0',
    marginLeft: '0',
    marginRight: '0',
    marginTop: '0',
    opacity: 1,
    paddingBottom: '10px',
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingTop: '10px',
    pointerEvents: 'none',
    position: 'absolute',
    right: 'auto',
    textIndent: '0',
    textDecoration: 'none',
    textTransform: 'uppercase',
    top: 'auto',
    transform: 'none',
    transition: 'none',
    visibility: 'visible',
    width: 'auto',
    zIndex: 214748364
};

export default styles;